import type { Step } from "react-joyride";

export const templateDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດຮ່າງເອກະສານ! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນທັງໝົດຂອງຮ່າງເອກະສານ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນ header. ທ່ານສາມາດກັບໄປຫນ້າລາຍການຮ່າງເອກະສານດ້ວຍປຸ່ມ 'ກັບໄປລາຍການ', ເບິ່ງຕົວຢ່າງຮ່າງເອກະສານດ້ວຍປຸ່ມ 'ເບີ່ງຕົວຢ່າງ', ດາວໂຫຼດຮ່າງເອກະສານດ້ວຍປຸ່ມ 'ດາວໂຫຼດຮ່າງເອກະສານ', ຫຼືແກ້ໄຂຮ່າງເອກະສານນີ້ດ້ວຍປຸ່ມ 'ແກ້ໄຂ' (ຖ້າທ່ານມີສິດແກ້ໄຂ).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນພື້ນຖານຂອງຮ່າງເອກະສານ. ທ່ານຈະເຫັນຊື່, ຄຳອະທິບາຍ, ປະເພດຮ່າງເອກະສານ, ພະແນກທີ່ໃຊ້, ແລະຫມາຍເຫດການນຳໃຊ້ຂອງຮ່າງເອກະສານນີ້.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-current-version"]',
    content:
      "ນີ້ແມ່ນພາກສ່ວນຮ່າງເອກະສານປັດຈຸບັນທີ່ໃຊ້ຢູ່. ທ່ານຈະເຫັນເວີຊັນປັດຈຸບັນ, ຂະໜາດຟາຍ, ປະເພດຟາຍ, ແລະວັນທີໃຊ້ງານລ່າສຸດ. ທ່ານຍັງສາມາດເບິ່ງຕົວຢ່າງ ຫຼື ດາວໂຫຼດເວີຊັນປັດຈຸບັນໄດ້ຈາກປຸ່ມທີ່ຢູ່ດ້ານລຸ່ມ.",
    placement: "top",
  },
  {
    target: '[data-tourid="detail-version-history"]',
    content:
      "ນີ້ແມ່ນພາກສ່ວນປະຫວັດການແກ້ໄຂເວີຊັນ. ທ່ານຈະເຫັນລາຍການເວີຊັນທັງໝົດຂອງຮ່າງເອກະສານນີ້, ລວມທັງເວີຊັນເກົ່າ. ສຳລັບແຕ່ລະເວີຊັນ, ທ່ານຈະເຫັນເລກເວີຊັນ, ປ່ຽນແປງ (changelog), ວັນທີປ່ອຍ, ແລະຜູ້ປ່ອຍ. ທ່ານຍັງສາມາດດາວໂຫຼດ ຫຼື ເບິ່ງເວີຊັນເກົ່າໄດ້.",
    placement: "top",
  },
];
